/**
 * Native form control glue.
 *
 * Single selects use `appearance: base-select`, so their option list is drawn by the page,
 * not the OS. An OS popup swallowed every key; the page-drawn list lets them bubble, so
 * Escape — meant to close the list — also closed the surrounding modal. Keys are therefore
 * kept inside an open list again. Only PROPAGATION is stopped: the browser's own handling
 * (Escape, arrows, Enter, type-ahead) is a default action and still runs.
 */
(function (window, document) {
    "use strict";

    if (!window.CSS || !CSS.supports || !CSS.supports("selector(:open)")) {
        return;
    }

    document.addEventListener(
        "keydown",
        function (event) {
            var select = event.target && event.target.closest ? event.target.closest("select") : null;

            if (select && select.matches(":open")) {
                event.stopPropagation();
            }
        },
        true
    );
})(window, document);

/**
 * Live „how the PDF prints the name" hint (`.js-titul-pdf-hint`) for a form with titul_pred /
 * jmeno / prijmeni / titul_za inputs. Must build the name exactly like
 * App\Helpers\ClientName::formal(); `hide` suppresses the hint (a company card).
 */
window.fiFormalNameHint = function (formName, hide) {
    var value = function (name) {
        return $.trim($("#frm-" + formName + "-" + name).val());
    };
    var name = $.grep([value("titul_pred"), value("jmeno"), value("prijmeni")], Boolean).join(" ");
    var suffix = value("titul_za");

    if (name && suffix) {
        name += ", " + suffix;
    }

    $(".js-titul-pdf-hint b").text(name);
    $(".js-titul-pdf-hint").prop("hidden", !name || Boolean(hide));
};
